<div class="emr-detail-comments-container ">
  <textarea class="commenttextarea" maxlength="1000" placeholder="Type here to reply." [(ngModel)]="commentText"></textarea>
  <div class="save-comment"><app-button (onClick)="saveComments()" text="ADD COMMENT"></app-button></div>
  <app-comments [commentItems]="commentItems"></app-comments>
</div>


